import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { GoogleMap as ReactMap, Marker, useJsApiLoader } from '@react-google-maps/api'

const GoogleMap = (props) => {
  const googleMapsApiKey = useSelector(state => state.config.input.config.googleMapsApiKey)
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey
  })
  if (!props.latitude || !props.longitude || !isLoaded || loadError) return null
  const coords = {
    lat: props.latitude,
    lng: props.longitude
  }

  return (
    <ReactMap
      mapContainerStyle={{
        width: '100%',
        height: props.height
      }}
      zoom={4}
      center={coords}
    >
      <Marker
        position={coords}
      />
    </ReactMap>
  )
}

GoogleMap.propTypes = {
  height: PropTypes.string.isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number
}

GoogleMap.defaultProps = {
  height: '400px'
}

export default React.memo(GoogleMap)
